class AlertableError extends Error {}

export default AlertableError;
